<div class="loader-holder-section sdps-is-absolute" role="status" aria-label="Loading">
    <div class="load-icon-center sdps-is-absolute">
      <span class="sch sch-spinner sch-spin-stepped" aria-hidden="true"></span>
    </div>
  </div>